<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir Movimentação Mínima"
                @click.stop="confirmarExcluir()"
            ></i>
        </span>
    </div>
</template>

<script>
import MovimentacoesMinimasServicos from './MovimentacoesMinimasServicos'

export default {
    props: {
        movimentacao: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Movimentações Mínimas',
                html: `Confirma a exclusão da Movimentação Mínima de Descrição <b>${this.movimentacao.descricao}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            let movimentacaoDto = {
                contratoId: this.movimentacao.contratoId,
                movimentacaoMinimaId: this.movimentacao.movimentacaoMinimaId
            }
            MovimentacoesMinimasServicos.excluir(movimentacaoDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Registro excluído com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterMovimentacoesAtualizadas')
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
